import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Card, CardContent } from '../components/ui/card';

const DocumentsPage = () => {
  const { i18n } = useTranslation();

  return (
    <div className="min-h-screen" data-testid="documents-page">
      <Navbar />
      <main className="pt-24 pb-12 px-4">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">
            {i18n.language === 'ar' ? 'المستندات' : 'Documents'}
          </h1>
          <Card>
            <CardContent className="flex flex-col items-center justify-center py-20">
              <FileText className="w-16 h-16 text-text-secondary mb-4" />
              <p className="text-text-secondary">
                {i18n.language === 'ar' ? 'لا توجد مستندات' : 'No documents yet'}
              </p>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DocumentsPage;
